import { useMasterData } from '../../../hooks/api/useMasterData';
import Refetch from '../../ui/Refetch';

interface FBOptionSortingProps {
    activeTab: number;
}

export default function FBOptionSorting({ activeTab }: FBOptionSortingProps) {

    const { refetchAllPackages, refetchGetCategory } = useMasterData()

    const getRefetchFunction = () => {
        switch (activeTab) {
            case 1:
            case 2:
                return refetchGetCategory;
            case 3:
                return refetchAllPackages;
            default:
                return undefined;
        }
    };

    const refetchFb = getRefetchFunction();

    return (
        <div className='w-full flex-1 flex-col'>
            <div className={`flex justify-between`}>
                <p className='text-sm font-medium flex items-center justify-center'>
                    Food and Beverage Management
                </p>    
                <div className='flex space-x-2'>
                    <Refetch refetch={refetchFb} size={23} btnStyle={''}/>
                </div>
            </div>
        </div>
    )
}
